import React from 'react';
import {BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import LoginForm from './components/auth/LoginForm';
import ConnectionsList from './components/connections/ConnectionsList';
import HedgeConfigsList from './components/hedge/HedgeConfigsList';
import Navbar from './components/common/Navbar';
import './App.css';

// Компонент для захищених маршрутів
const ProtectedRoute = ({children}) => {
    const isAuthenticated = localStorage.getItem('token') !== null;

    if (!isAuthenticated) {
        return <Navigate to="/login" replace/>;
    }

    return children;
};

function App() {
    return (
        <Router>
            <div className="app">
                <Routes>
                    <Route path="/login" element={<LoginForm/>}/>
                    <Route
                        path="/connections"
                        element={
                            <ProtectedRoute>
                                <div className="app-container">
                                    <Navbar/>
                                    <div className="content">
                                        <ConnectionsList/>
                                    </div>
                                </div>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/hedge-configs"
                        element={
                            <ProtectedRoute>
                                <div className="app-container">
                                    <Navbar/>
                                    <div className="content">
                                        <HedgeConfigsList/>
                                    </div>
                                </div>
                            </ProtectedRoute>
                        }
                    />
                    <Route path="/" element={<Navigate to="/login" replace/>}/>
                </Routes>
            </div>
        </Router>
    );
}

export default App;